export const get = <T>(key: string): T | null => {
    try {
        const raw = window.localStorage.getItem(key);
        if (raw === null) {
            return null;
        }
        return JSON.parse(raw) as T;
    } catch {
        return null;
    }
};

export const set = <T>(key: string, value: T): void => {
    window.localStorage.setItem(key, JSON.stringify(value));
};

export const remove = (key: string): void => {
    window.localStorage.removeItem(key);
};

// Per-tab variants: a new tab starts empty.
export const getSession = <T>(key: string): T | null => {
    try {
        const raw = window.sessionStorage.getItem(key);
        if (raw === null) {
            return null;
        }
        return JSON.parse(raw) as T;
    } catch {
        return null;
    }
};

export const setSession = <T>(key: string, value: T): void => {
    window.sessionStorage.setItem(key, JSON.stringify(value));
};

export const removeSession = (key: string): void => {
    window.sessionStorage.removeItem(key);
};
